import throttle from 'lodash/throttle';

$(function () {
  const $backToTop = $('.js-back-to-top');
  const $ntfToastBtn = $('.ntf-toast--btn');
  const $fixedCornerWrap = $('#js-fixed-corner__wrap');
  const $footer = $('.site-footer');
  if ($backToTop.length === 0) {
    return;
  }
  const scrollToTop = () => {
    $("html, body").animate({ scrollTop: 0 }, 300);
  };

  // Check if back to top button exist
  if ($backToTop.length) {
    // Add click event to scroll top
    $backToTop.on("click", function () {
      scrollToTop();
    });

    // Toggle btt button visibility based on scroll position
    $(window).on(
      "scroll resize", throttle(function () {
      const $window = $(this);
      const docHeight = $(document).height();
      const windowHeight = window.screen.height;
      const footerWrapperHeight = docHeight - $footer.outerHeight() - windowHeight;
      const scrollPos = $(this).scrollTop();
      const scrollPosY = $window.scrollTop();
      if (scrollPos > 250) {
        $backToTop.stop().fadeIn(250);
      } else {
        $backToTop.stop().fadeOut();
      }

      if (scrollPosY >= footerWrapperHeight) {
        $ntfToastBtn.addClass('u-hide').next().addClass('fixed-corner--full-width');
      } else {
        $ntfToastBtn.removeClass('u-hide');
        $fixedCornerWrap.removeClass('fixed-corner--full-width');
      }

    }, 100));
  };
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/back-to-top.js